// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFoundProperty = () => {
    const { t } = useTranslation();

    const linkStyle: React.CSSProperties = {
        textDecoration: "none",
        padding: "12px 24px",
        background: "#00345F", 
        color: "white",
        fontSize: "16px",
        borderRadius: "8px",
        transition: "background 0.3s"
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px", maxWidth: "500px", margin: "40px auto" }}>

            <img
                src="https://cdn-icons-png.flaticon.com/512/4076/4076432.png"
                alt={`${t('propertyList.notFound.imageAlt')}`}
                width="120"
                style={{ opacity: 0.7, marginBottom: "20px" }}
            />

            <h2 style={{ color: "#020202", fontSize: "22px", marginBottom: "10px" }}>
                {t('propertyList.notFound.title')}
            </h2>

            <p style={{ color: "#020202", opacity: 0.7, fontSize: "16px", marginBottom: "20px" }}>
                {t('propertyList.notFound.suggestion')}
            </p>

            <Link
                className="btn btn-primary mt-4"
                title={t('navigation.homeLinkTitle') || 'Home'}
                to="/immobili"
                style={linkStyle}
            >
                {t('propertyList.notFound.backToSearchLink')}
            </Link>

        </div>
    )
}

export default NotFoundProperty;